import { Button, Modal, Message } from "semantic-ui-react";
import React from "react";

const FRSClientSecretModal = ({ open, onClose, onConfirm }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Modal.Header>Generate Client Secret</Modal.Header>
            <Modal.Content>
                <Message
                    warning
                    header='Are you sure you want to (re)generate the FRS Client Secret?'
                    content='This will disable the existing FRS Client Secret.'
                />
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={onConfirm}>Ok</Button>
                <Button negative onClick={onClose}>Cancel</Button>
            </Modal.Actions>
        </Modal>
    )
}

export default FRSClientSecretModal;